import { Component } from '@angular/core';
import { CommonConstants } from '../common/utilities/commonConstants';
import { SharedService } from 'src/app/common/services/sharedService';

@Component({
    selector: 'customFooter',
    templateUrl: './footer.template.html',
    styleUrls: ['./footer.style.scss']
})
export class FooterComponent {
    public footerText = CommonConstants.footerText;
    constructor(public sharedService: SharedService) { }
}
